import { issuanceTypes } from 'types/projectType';

export const calculateAmountStocks = (project, amount = 1) => {
  if (project.issuanceType === issuanceTypes.INDIVIDUAL) {
    return project?.nodeValue * amount;
  }
  return project?.nodeValue * project?.nodePerPackage * amount;
};

export const calculateStocksFromAmount = (project, amount) => {
  if (project?.issuanceType === issuanceTypes.INDIVIDUAL) {
    return amount / project?.nodeValue;
  }
  return amount / (project?.nodeValue * project?.nodePerPackage);
};
